const keys = {
    PHARMACY_ID: 'pharmacyId',
    TOKEN: 'token',
    LANGUAGE: 'language',
}

const getStorage = (keyToUse, defaultData = '') => {
    return localStorage.getItem(keyToUse) ?? defaultData;
}

const setStorage = (keyToUse, value) => {
    return localStorage.setItem(keyToUse, value);
}

const removeStorage = (keyToUse) => {
    return localStorage.removeItem(keyToUse);
}

export const getToken = () => {
    return getStorage(keys.TOKEN);
}

export const setToken = (token) => {
    return setStorage(keys.TOKEN, token);
}

export const removeToken = () => {
    return removeStorage(keys.TOKEN);
}

export const getPharmacyId = () => {
    return getStorage(keys.PHARMACY_ID);
}

export const setPharmacyId = (pharmacyId) => {
    return setStorage(keys.PHARMACY_ID, pharmacyId);
}

export const getLanguage = () => {
    const selectedLanguage = getStorage(keys.LANGUAGE);
    if (!selectedLanguage) {
        setStorage(keys.LANGUAGE, 'de');
        return 'de';
    }
    return selectedLanguage;
}

export const setLanguage = (language) => {
    setStorage(keys.LANGUAGE, language);
}